module.exports = __webpack_public_path__ + "static/media/brainwonders.480e6ba1.webp";